import { TextStyle } from '@optimus-web/common';
import { TypographyProps } from '../../types';
import { Typography } from '../../Typography';

export type TitleProps = Omit<TypographyProps, 'textStyle' | 'as'> & { level: 1 | 2 | 3 };

const getTitleProps = (level: 1 | 2 | 3): { as: 'h1' | 'h2' | 'h3'; textStyle: `${TextStyle}` } => {
    switch (level) {
        case 1:
            return {
                as: 'h1',
                textStyle: 'titleLargeStrong',
            };
        case 2:
            return {
                as: 'h2',
                textStyle: 'titleMediumStrong',
            };
        case 3:
            return {
                as: 'h3',
                textStyle: 'titleSmallStrong',
            };
    }
};

export const Title = ({ level, ...props }: TitleProps) => <Typography {...props} {...getTitleProps(level)} />;
